module.exports = __webpack_public_path__ + "static/img/award4_active.852e33b.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award4_active.png
// module id = /uiG
// module chunks = 7